<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useIdle, useTimestamp } from '@vueuse/core'

import EmployeeShiftOfferDialog from '../../../employee_shift/components/EmployeeShiftOfferDialog.vue'
import EmployeeArchiveDialog from '../../../employees/components/dialogs/EmployeeArchiveDialog.vue'
import EmployeeSelectDialog from '../../../employees/components/dialogs/EmployeeSelectDialog.vue'
import ScheduleCopyDialog from '../../../schedule/components/dialogs/ScheduleCopyDialog.vue'
import ScheduleDuplicateDialog from '../../../schedule/components/dialogs/ScheduleDuplicateDialog.vue'
import SchedulePublishDialog from '../../../schedule/components/dialogs/SchedulePublishDialog.vue'
import ScheduleShiftOffersDialog from '../../../schedule/components/dialogs/ScheduleShiftOffersDialog.vue'
import ShiftPresetDetailDialog from '../../../shift_presets/components/dialogs/ShiftPresetDetailDialog.vue'
import ShiftConflictDialog from '../../../shifts/components/ShiftConflictDialog.vue'
import HeaderNavigation from './HeaderNavigation.vue'

import { useSiteContext } from '../../../sites/composables/useSiteContext.ts'

import { useAuthUserStore } from '../../../user/authUserStore'

const route = useRoute()

const authUserStore = useAuthUserStore()
const { user } = storeToRefs(authUserStore)

const { site } = useSiteContext()

// const toast = useToast()
// TODO: Implement logout on idle
const inactivityToastGroup = 'inactivity'
// const inactivityToastVisible = ref(false)
// const showInactivityToast = () => {
//   if (!inactivityToastVisible.value) {
//     toast.add({ group: inactivityToastGroup, severity: 'warn', summary: 'Inactivity Notice', detail: 'You have been idle for too long. You will be logged out soon.' })

//     inactivityToastVisible.value = true
//   }
// }

const IDLE_THRESHOLD_START_SECONDS = 60 // The time in seconds before the inactivity toast is shown. TODO: Increase to 180 after testing.
const IDLE_THRESHOLD_END_SECONDS = 900 // The time in seconds before the user is logged out.

const duration = IDLE_THRESHOLD_END_SECONDS * 1000
const { lastActive } = useIdle(duration)
const now = useTimestamp({ interval: 1000 })
const idleFor = computed(() => Math.floor(now.value - lastActive.value) / 1000)
const durationSeconds = computed(() => duration / 1000)
const timeElapsedPercentage = computed(
  () => (idleFor.value / durationSeconds.value) * 100,
)

const signingOut = ref(false)

watch(idleFor, async (newIdleFor) => {
  if (
    newIdleFor > IDLE_THRESHOLD_START_SECONDS &&
    newIdleFor < IDLE_THRESHOLD_END_SECONDS
  ) {
    //showInactivityToast()
  } else if (newIdleFor >= IDLE_THRESHOLD_END_SECONDS) {
    if (!signingOut.value) {
      //signingOut.value = true
      //await authUserStore.signOut()
      //signingOut.value = false
    }
  } else {
    //toast.removeGroup(inactivityToastGroup)
    //inactivityToastVisible.value = false
  }
})
</script>

<template>
  <!-- TODO: THEME -->
  <div class="flex h-screen flex-col">
    <HeaderNavigation v-if="user && !route.meta?.hideHeader" :user="user" />

    <!-- A page's toolbar, when it has one (the calendar's menu bar) -->
    <router-view name="contentHeader" />

    <router-view />
  </div>

  <ConfirmDialog :group="'dialog'" />

  <ConfirmPopup :group="'popup'" />

  <ConfirmPopup />

  <Toast v-if="false" :group="inactivityToastGroup" position="bottom-center">
    <template #message="slotProps">
      <div class="flex flex-auto flex-col">
        <div>
          <span class="font-semibold">{{ slotProps.message.summary }}</span>
        </div>
        <div>{{ slotProps.message.detail }}</div>
        <div>
          Timer (Seconds): {{ idleFor.toFixed(0) }} / {{ durationSeconds }}
        </div>
        <ProgressBar
          class="my-1"
          :value="timeElapsedPercentage"
          :show-value="false"
        />
      </div>
    </template>
  </Toast>

  <Toast
    :group="'hint'"
    position="bottom-center"
    :close-button-props="{ class: 'hidden' }"
  >
    <template #message="slotProps">
      <div class="w-full flex justify-center">
        <div>{{ slotProps.message.detail }}</div>
      </div>
    </template>
  </Toast>

  <template v-if="site">
    <EmployeeShiftOfferDialog />

    <EmployeeArchiveDialog :site="site" />

    <EmployeeSelectDialog :site="site" />

    <ShiftConflictDialog :site="site" />

    <ScheduleCopyDialog :site="site" />

    <ScheduleDuplicateDialog :site-id="site.id" />

    <ScheduleShiftOffersDialog :site-id="site.id" />

    <SchedulePublishDialog :site-id="site.id" />

    <ShiftPresetDetailDialog :site-id="site.id" />
  </template>
</template>
